import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  putTopicApiCrud,
  type PutTopicRequest,
  type IdentifiedTopic,
} from "@/generated/fastapi";

export async function putTopic(
  accessToken: string | null | undefined,
  request: PutTopicRequest,
): Promise<IdentifiedTopic | null> {
  try {
    const response = await putTopicApiCrud({
      client: browserFastApiClient,
      auth: requireFastApiAccessToken(accessToken),
      body: request,
    });

    if (response.status !== 200 || !response.data) {
      console.error("Failed to update Identified Topic");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Error updating Identified Topic:", error);
    return null;
  }
}
